<div class="modal fade auth-modal" id="write-intro" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="d-flex flex-row justify-content-between mt-3 mb-2 px-3">
                    <span class="modal-title">Write an intro about you</span>
                    <i class="fas fa-times modal-close" data-dismiss="modal" (click)="clearData()"></i>
                </div>
                <span class="my-2 px-3">Phasellus sollicitudin volutpat arcu in interdum. Integer ut </span>
                <div class="horizontal-line my-3"></div>
                <div class="d-flex flex-column mx-3">
                    <span class="input-label mb-2">Write your info</span>
                    <textarea class="form-control form-control-sm" rows="15" [(ngModel)]="intro"></textarea>
                </div>
                <div class="d-flex flex-row justify-content-end mt-4 mx-3 mb-3">
                    <button class="btn btn-cancel mr-2" data-dismiss="modal" (click)="clearData()">Will do Later</button>
                    <button class="btn btn-theme" [disabled]="intro.length < 10"
                    (click)="addIntro()">Submit</button>
                </div>
            </div>
        </div>
    </div>
</div>